module.exports = __webpack_public_path__ + "assets/align-to-left-icon.7b5ae798.svg";